export const profile = {
  name: "Imran Melikov",
  statement: "Providing professional IT services. Taking your business to the next level with modern and innovative solutions.",
  email: "imran.melikov84@gmail.com",
};

export const navigation = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Technology", href: "/technology" },
  { label: "Projects", href: "/projects" },
  { label: "Chess", href: "/chess" },
  { label: "Business", href: "/business" },
  { label: "Contact", href: "/contact" },
];

export const areas = [
  { label: "Technology", href: "/technology", note: "Security and software" },
  { label: "Projects", href: "/projects", note: "Selected work" },
  { label: "Chess", href: "/chess", note: "A personal interest" },
  { label: "Business", href: "/business", note: "MobilTech" },
];

export const socials = [
  { label: "LinkedIn", href: "https://linkedin.com/in/imran-melikov" },
  { label: "GitHub", href: "https://github.com/imranmelikov0" },
  { label: "Instagram", href: "https://instagram.com/imranmelikov225" },
  { label: "YouTube", href: "https://www.youtube.com/@imranmelikov" },
  { label: "Udemy", href: "https://www.udemy.com/course/chess-essential-strategies/" },
  { label: "Email", href: "mailto:imran.melikov84@gmail.com" },
  {
    label: "Play Store",
    href: "https://play.google.com/store/apps/details?id=com.imranmelikov.cinemovie",
  },
];

export const about = {
  lead: "Who is Imran Melikov?",
  detail:
    "Imran Melikov has been actively involved in technology for the past five years, with a particular focus on Cyber security and Android development. Alongside his technical journey, he founded Intern Vision, an internship and learning community focused on helping students and beginners gain practical experience and develop their skills.Beyond technology, He has been developing his skills in chess, building a growing community through teams, tournaments, games, educational content, and courses. He also works in phone retail and wholesale, connecting technology with business and sales.He continues to learn, build, and explore new opportunities across technology, education, chess, and business.",
};

export const aboutLinks = [
  { href: "/technology", label: "Technology", note: "Work and skills" },
  { href: "/technology#companies", label: "Companies", note: "Nexora and Intern Vision" },
  { href: "/projects", label: "Projects", note: "Software projects" },
  { href: "/chess", label: "Chess", note: "A personal interest" },
  { href: "/business", label: "Business", note: "MobilTech" },
  { href: "/contact", label: "Contact", note: "Email and form" },
];

export function isListed(block) {
  return Boolean(block && (block.enabled || block.preview));
}

export const technology = {
  lede: "Cybersecurity, Android development, and the work around them.",
  intro:
    "Cybersecurity and Android development are the main focus. The work also includes web software, data, interface design, and applied machine learning, much of it through Nexora.",
  teaching: {
    enabled: false,
    preview: false,
    title: "Teaching",
    items: [
      {
        label: "Teaching",
        title: "Teaching and mentoring can be listed here, separate from the technical work.",
        href: "https://internvision.imranmelikov.org",
        image: "",
        poster: "tech",
        action: "View teaching",
        video: false,
        enabled: true,
        home: false,
        page: true,
      },
    ],
  },
  videos: {
    enabled: false,
    preview: false,
    title: "Video",
    items: [
      {
        label: "YouTube",
        title: "The Trap That EVERY Beginner Needs to Know",
        href: "https://www.youtube.com/watch?v=0YQLK9OM17M",
        image: "https://i.ytimg.com/vi/0YQLK9OM17M/hqdefault.jpg",
        action: "View video",
        enabled: true,
        home: true,
        page: true,
      },
      {
        label: "Instagram",
        title: "",
        href: "https://instagram.com/imranmelikov225",
        image: "",
        action: "View video",
        enabled: true,
        home: true,
        page: true,
      },
    ],
  },
  course: {
    enabled: false,
    preview: false,
    title: "Course",
    text: "A course can be linked from this page.",
    href: "https://nexora.imranmelikov.org",
    image: "",
    poster: "tech",
    action: "View course",
  },
  products: {
    enabled: false,
    preview: false,
    title: "Products",
    items: [
      {
        title: "Organization management",
        text: "A website for managing a company. It includes a private database and analytics.",
        href: "/contact",
        image: "",
        poster: "tech",
        action: "Enquire",
        enabled: true,
        home: true,
        page: true,
      },
    ],
    videos: [
      {
        label: "Video",
        title: "",
        href: "",
        image: "",
        action: "View video",
        poster: "tech",
        enabled: false,
        home: true,
        page: true,
      },
    ],
  },
  areas: [
    {
      title: "Cybersecurity",
      text: "Security work and penetration testing.",
    },
    {
      title: "Mobile development",
      text: "Native Android and cross-platform applications.",
    },
    {
      title: "Web development",
      text: "Full-stack web applications.",
    },
    {
      title: "Data analytics",
      text: "Analysis, visualization, and business intelligence.",
    },
    {
      title: "UX/UI design",
      text: "Interface design for web and mobile.",
    },
    {
      title: "AI / ML",
      text: "Applied artificial intelligence and machine learning.",
    },
  ],
};

export const companies = [
  {
    name: "Nexora",
    role: "Founder",
    text: "IT services. Software development, digital security, and open-source systems. Consulting and technical support are free of charge and run on a volunteer basis, for individuals and organizations.",
    href: "https://nexora.imranmelikov.org",
    linkLabel: "Visit Nexora",
  },
  {
    name: "Intern Vision",
    role: "Founder",
    text: "Internships for students and young professionals in software development, cybersecurity, data analytics, and UX/UI design.",
    href: "https://internvision.imranmelikov.org",
    linkLabel: "View positions",
    email: "contact.internvision@gmail.com",
  },
];

export function listedProjects(list = projects) {
  return list.filter((project) => project.enabled !== false);
}

export function paletteFor(project) {
  if (!project?.palettes) return project?.palette || null;
  return project.warm ? project.palettes.warm : project.palettes.cool;
}

export const projects = [
  {
    title: "CineMovie",
    category: "Android",
    summary: "A voice-controlled application for browsing movies, series, and actors.",
    description:
      "Browse and control the movie experience with voice commands. The app covers films, series, and actors, with favorites, a watchlist, a watched list, and recommendations.",
    tags: ["Movies", "Series", "Actors", "Voice recognition"],
    marks: ["film", "mic"],
    href: "/cinemovie",
    store: "https://play.google.com/store/apps/details?id=com.imranmelikov.cinemovie",
    image: "/cinemovielogo.jpg",
    enabled: true,
    technology: true,
    ads: true,
    features: [
      { title: "Voice control", text: "Navigate with voice commands." },
      { title: "Search", text: "Find titles from inside the app." },
      { title: "Recommendations", text: "Suggestions based on saved preferences." },
      { title: "Library", text: "Favorites, a watchlist, and a watched list." },
    ],
  },
  {
    title: "QR Barcode",
    category: "Android",
    summary: "A QR and barcode app, still in development.",
    description: "Scan and create QR codes and barcodes.",
    tags: ["QR", "Barcode"],
    marks: ["qr", "barcode"],
    href: "/qr-barcode",
    store: "",
    image: "/qrbarcode.jpg",
    enabled: true,
    technology: false,
    ads: false,
    landing: true,
    theme: "qr",
    palette: {
      bg: "#04110c",
      ink: "#f3fff8",
      muted: "#b7d7c8",
      accent: "#3dff7a",
      accent2: "#7ef0ff",
      card: "rgba(6, 28, 20, 0.78)",
    },
    features: [
      { title: "Scan", text: "Read a QR code or a barcode." },
      { title: "Create", text: "Make a code from text." },
    ],
    privacy: {
      name: "Privacy Policy",
      app: "QR & Barcode Studio",
      developer: "Imran Melikov",
      dateLabel: "Last updated",
      updated: "7 October 2026",
      contact: "imran.melikov84@gmail.com",
      intro: [
        "QR & Barcode Studio creates QR codes and barcodes. It reads them with the camera or with an image you choose. You do not need to create an account.",
      ],
      sections: [
        {
          heading: "Data stored on the device",
          paragraphs: [
            "Codes you create or scan, and the time they were saved, stay in the history on this phone. Settings such as language and theme also stay on this phone. This history is not uploaded to the developer.",
            "If you use Android backup, this local data may be included in your phone backup. The backup follows your Google account’s backup rules.",
          ],
        },
        {
          heading: "Camera",
          paragraphs: [
            "The camera is used only while the scanner is open, to read a code. The image is processed on your device and is not sent to the developer.",
          ],
        },
        {
          heading: "Actions you start",
          paragraphs: [
            "Opening a link, placing a call, sending a message or email, opening a map, or saving a contact starts only when you press a button. After that, the relevant app works under its own rules.",
          ],
        },
        {
          ads: true,
          heading: "Ads",
          paragraphs: [
            [
              { text: "In free use, the app shows banner ads. Ads are provided by Google (AdMob). Google may process the advertising ID and device information to show and measure ads. This processing is subject to Google’s privacy policy: " },
              { text: "https://policies.google.com/privacy", href: "https://policies.google.com/privacy" },
            ],
            [
              { text: "You can manage personalized ads at " },
              { text: "https://adssettings.google.com", href: "https://adssettings.google.com" },
              { text: "." },
            ],
            "Code contents and camera images are not sent to the ad network or to the developer. Personal data is not sold.",
          ],
        },
        {
          ads: true,
          heading: "Premium",
          paragraphs: [
            [
              { text: "A one-time purchase through Google Play is offered to remove ads. There is no subscription. Google Play takes the payment. Your card number does not reach the developer. Purchase status is read from Google Play. “Restore purchase” checks the same Google account again. Refunds follow Google Play’s rules. Google Play Terms of Service: " },
              { text: "https://play.google.com/about/play-terms/", href: "https://play.google.com/about/play-terms/" },
            ],
          ],
        },
        {
          heading: "Children",
          paragraphs: ["The app is not directed at children under 13."],
        },
        {
          heading: "Contact",
          paragraphs: [
            [
              { text: "For questions: " },
              { text: "imran.melikov84@gmail.com", href: "mailto:imran.melikov84@gmail.com" },
            ],
          ],
        },
        {
          heading: "Changes",
          paragraphs: [
            "If this text changes, the current version appears on this page and in the app.",
            [
              { text: "Terms of Use: " },
              { text: "https://imranmelikov.org/qr-barcode#terms", href: "/qr-barcode#terms" },
            ],
          ],
        },
      ],
    },
    terms: {
      name: "Terms of Use",
      app: "QR & Barcode Studio",
      developer: "Imran Melikov",
      dateLabel: "Last updated",
      updated: "7 October 2026",
      contact: "imran.melikov84@gmail.com",
      intro: [
        "QR & Barcode Studio can be used for free.",
        { ads: true, content: "In free use, banner ads are shown." },
      ],
      sections: [
        {
          ads: true,
          heading: "Premium",
          paragraphs: [
            [
              { text: "To remove ads, you can buy Premium once through Google Play. The price is shown in Google Play before you pay. Premium is not a subscription. Restore purchase checks the same Google account again. Refunds follow Google Play’s rules. Google Play Terms of Service: " },
              { text: "https://play.google.com/about/play-terms/", href: "https://play.google.com/about/play-terms/" },
            ],
          ],
        },
        {
          heading: "Use",
          paragraphs: [
            "You may use the app to create and read codes for lawful purposes.",
            "You are responsible for the content you encode and for the link, number, or address you choose to open. A code can point anywhere. Check it before you open it.",
            "The app is provided as is. There is no guarantee that every code will be read or that another app will accept it.",
            { ads: true, content: "Premium removes ads. It does not change how codes are created or read." },
            "Do not use the app for unlawful activity, to mislead others, or to spread harmful links.",
          ],
        },
        {
          heading: "Changes",
          paragraphs: [
            { ads: false, content: "The developer may update or discontinue the app. These terms may be updated on this page and inside the app." },
            { ads: true, content: "The developer may update or discontinue the app, the ads, and the Premium offer. These terms may be updated on this page and inside the app." },
          ],
        },
        {
          heading: "Contact",
          paragraphs: [
            [
              { text: "imran.melikov84@gmail.com", href: "mailto:imran.melikov84@gmail.com" },
            ],
            [
              { text: "Privacy Policy: " },
              { text: "https://imranmelikov.org/qr-barcode#privacy", href: "/qr-barcode#privacy" },
            ],
            [
              { text: "Google Privacy Policy: " },
              { text: "https://policies.google.com/privacy", href: "https://policies.google.com/privacy" },
            ],
          ],
        },
      ],
    },
  },
  {
    title: "Expense Tracker",
    category: "Android",
    summary: "An expense tracker, still in development.",
    description: "Record spending and review it later.",
    tags: ["Expenses", "Budget"],
    marks: ["wallet"],
    href: "/expense-tracker",
    store: "",
    image: "/expensetracker.png",
    enabled: true,
    technology: false,
    ads: false,
    landing: true,
    theme: "expense",
    palette: {
      bg: "#070714",
      ink: "#f3f4ff",
      muted: "#c3c6e4",
      accent: "#7c6bff",
      accent2: "#4ea2ff",
      card: "rgba(14, 16, 40, 0.78)",
    },
    features: [
      { title: "Record", text: "Add an expense when it happens." },
      { title: "Review", text: "Look back at what was spent." },
    ],
    privacy: {
      name: "Privacy Policy — Expense Tracker / Personal Finance",
      developer: "Imran Melikov",
      dateLabel: "Last updated",
      updated: "7 October 2026",
      contactLabel: "Contact / support",
      contact: "https://imranmelikov.org/contact",
      package: "com.imranmelikov.expensetracker",
      intro: [
        "This Privacy Policy describes how the Expense Tracker mobile application (“the App”) handles information. By installing or using the App, you agree to this policy.",
      ],
      sections: [
        {
          heading: "1. Summary",
          items: [
            "Your financial records are stored on your device.",
            "The App does not create an online account and does not sync your ledger to our servers.",
            "We do not sell your personal data.",
            { ads: true, content: "Ads and in-app purchases use Google services." },
          ],
        },
        {
          heading: "2. Information stored on your device",
          paragraphs: [
            "The App stores the following locally (for example with an on-device database and preferences):",
          ],
          items: [
            "Accounts, categories, transactions, recurring templates, budgets, savings goals",
            "Notes, merchant names, amounts, dates, and currencies you enter",
            "App settings (language, theme, currency preference, week start, dashboard layout)",
            "Optional app lock: a hashed PIN and related flags (the PIN itself is not stored in plain text)",
            "Flags related to sample/demo data",
          ],
          notes: ["This information stays on your device unless you export or share it."],
        },
        {
          heading: "3. Backup and export (user-controlled)",
          paragraphs: ["You may create:"],
          items: [
            "A JSON backup of your data to restore after reinstall",
            "CSV / Excel / PDF reports",
          ],
          notes: [
            "These files are created on your device. If you share them (email, Drive, messaging apps, and similar), the destination service’s privacy policy applies. We do not receive those files automatically.",
            "PIN / lock credentials are not included in the backup file.",
          ],
        },
        {
          heading: "4. Data we do not collect ourselves",
          paragraphs: ["We do not operate a backend that receives:"],
          items: [
            "Your transactions or balances",
            "Your PIN",
            "Your name, email, or phone number through this App (unless you contact us separately)",
          ],
        },
        {
          ads: true,
          heading: "5. Advertising",
          items: [
            "Ads are served by Google AdMob (or Google advertising services).",
            "Google may process device identifiers (such as Advertising ID), IP address, approximate location derived from IP, device/app technical data, and interaction data, according to Google’s policies.",
          ],
          notes: [
            [
              { text: "See: " },
              { text: "https://policies.google.com/privacy", href: "https://policies.google.com/privacy" },
              { text: " and " },
              { text: "https://policies.google.com/technologies/partner-sites", href: "https://policies.google.com/technologies/partner-sites" },
            ],
            "Purchasing Premium through Google Play removes ads on that Google account for this App. Payment is processed by Google. We do not receive your full payment card details.",
          ],
        },
        {
          ads: true,
          heading: "6. Google Play Billing",
          paragraphs: ["If you buy Premium:"],
          items: [
            "Purchase status is handled via Google Play Billing.",
            "The App stores a local flag that Premium is active so ads can be hidden.",
            "Google’s terms and privacy policy apply to payments and refunds.",
          ],
        },
        {
          heading: "7. Permissions",
          paragraphs: [
            { ads: false, content: "The App may use Internet access to open links (website, Play Store, rate us)." },
            { ads: true, content: "The App may use Internet access to open links (website, Play Store, rate us), to load ads, and to contact Google Play Billing." },
            "No continuous background location access is required for core finance features.",
          ],
        },
        {
          heading: "8. Children",
          paragraphs: [
            "The App is not directed at children under 13 (or the minimum age required in your country). We do not knowingly collect personal information from children. If you believe a child has provided data through contact channels, contact us and we will help address it.",
          ],
        },
        {
          heading: "9. Data retention and deletion",
          items: [
            "Local data remains until you delete it in the App, clear app data, or uninstall the App.",
            "Uninstalling removes on-device App data (unless you previously exported a backup).",
            "You can bulk-delete records from Settings while keeping accounts/categories as designed in the App.",
            "Backups you saved outside the App remain under your control until you delete them.",
          ],
        },
        {
          heading: "10. Security",
          paragraphs: [
            "We use reasonable on-device measures (for example hashed PIN storage). No method of electronic storage is 100% secure. Protect your device lock screen and any backup files you share.",
          ],
        },
        {
          heading: "11. International users",
          paragraphs: [
            "The App may be used in multiple countries.",
            { ads: true, content: "Processing by Google for ads and billing may occur in other regions under Google’s terms." },
          ],
        },
        {
          heading: "12. Changes",
          paragraphs: [
            "We may update this Privacy Policy. The “Last updated” date will change. Continued use after an update means you accept the revised policy. Material changes should also be reflected in the URL you submit to Google Play.",
          ],
        },
        {
          heading: "13. Contact",
          paragraphs: [
            [
              { text: "Website: " },
              { text: "https://imranmelikov.org", href: "https://imranmelikov.org" },
            ],
            [
              { text: "Support: " },
              { text: "https://imranmelikov.org/contact", href: "https://imranmelikov.org/contact" },
            ],
          ],
        },
      ],
    },
    terms: {
      name: "Terms of Use — Expense Tracker / Personal Finance",
      developer: "Imran Melikov",
      dateLabel: "Last updated",
      updated: "7 October 2026",
      contactLabel: "Contact",
      contact: "https://imranmelikov.org/contact",
      intro: ["By downloading or using the App, you agree to these Terms."],
      sections: [
        {
          heading: "1. What the App is",
          paragraphs: [
            "The App helps you record personal income, expenses, budgets, and related notes on your device. It is a personal record-keeping tool, not financial, tax, investment, or legal advice.",
          ],
        },
        {
          heading: "2. Your responsibilities",
          items: [
            "You are responsible for the accuracy of data you enter.",
            "Keep backups if you need your data after uninstall or device loss.",
            "Protect your device and optional PIN.",
            "Use the App only for lawful purposes.",
          ],
        },
        {
          heading: "3. Accounts and data",
          paragraphs: [
            "There is no required cloud account operated by us for the ledger. Data is stored on your device unless you export or share it.",
          ],
        },
        {
          ads: true,
          heading: "4. Purchases (Premium)",
          paragraphs: [
            "Purchases are made through Google Play. Pricing, taxes, and refunds follow Google Play’s rules. We do not control Google’s payment systems.",
          ],
        },
        {
          ads: true,
          heading: "5. Ads",
          paragraphs: [
            "Third-party ad networks (such as Google AdMob) show ads. Premium removes ads when it is purchased and active.",
          ],
        },
        {
          heading: "6. Availability",
          paragraphs: [
            "The App is provided “as is”. Features may change. We do not guarantee uninterrupted operation or that the App will meet every need.",
          ],
        },
        {
          heading: "7. Limitation of liability",
          paragraphs: [
            "To the maximum extent allowed by law, we are not liable for loss of data, financial decisions you make using the App, or damages arising from use or inability to use the App. Always keep your own backups.",
          ],
        },
        {
          heading: "8. Third-party services",
          paragraphs: [
            "Links to websites or the Play Store open third-party services. Their terms and privacy policies apply.",
          ],
        },
        {
          heading: "9. Changes",
          paragraphs: [
            "We may update these Terms. Continued use after changes means acceptance. The latest version will be published at your public Terms URL.",
          ],
        },
        {
          heading: "10. Contact",
          paragraphs: [
            [
              { text: "https://imranmelikov.org/contact", href: "https://imranmelikov.org/contact" },
            ],
          ],
        },
      ],
    },
  },
  {
    title: "AI Resume Builder",
    category: "Android",
    summary: "A resume builder, still in development.",
    description: "Draft and edit a resume.",
    tags: ["Resume", "Writing"],
    marks: ["resume", "ai"],
    href: "/ai-resume",
    store: "",
    image: "/airesumebuilder.jpg",
    enabled: true,
    technology: false,
    ads: false,
    landing: true,
    theme: "resume",
    warm: true,
    palettes: {
      cool: {
        bg: "#07061a",
        ink: "#f4f2ff",
        muted: "#c4bddf",
        accent: "#8b7cff",
        accent2: "#4ea2ff",
        card: "rgba(18, 16, 42, 0.78)",
      },
      warm: {
        bg: "#140806",
        ink: "#fff6ef",
        muted: "#e4cbb8",
        accent: "#ff4d3a",
        accent2: "#ff8a3d",
        accent3: "#ffd15c",
        card: "rgba(42, 16, 10, 0.78)",
      },
    },
    features: [
      { title: "Draft", text: "Start a resume from what you enter." },
      { title: "Edit", text: "Change the draft before it leaves the app." },
    ],
    privacy: {
      name: "Privacy Policy — AI Resume Builder & CV Maker",
      developer: "Imran Melikov",
      dateLabel: "Last updated",
      updated: "7 October 2026",
      contactLabel: "Contact",
      contact: "https://imranmelikov.org/contact",
      intro: [
        "This Privacy Policy explains how the AI Resume Builder & CV Maker app (“App”, “we”, “us”) handles information. The App is developed by Imran Melikov.",
      ],
      sections: [
        {
          heading: "1. Local data",
          paragraphs: [
            "The App stores your resumes, profile photo, preferences, and related files primarily on your device (local database and device storage). We do not operate a resume cloud that uploads your CV content to our own servers by default.",
          ],
        },
        {
          heading: "2. Purchases (Premium)",
          paragraphs: [
            "If you buy Premium, payment is processed by Google Play. We receive purchase status needed to unlock features (for example whether Premium is active). Google handles payment details under Google’s policies. Premium is linked to your Google account on the device.",
          ],
        },
        {
          heading: "3. Backup files you create",
          paragraphs: [
            "If you use Premium backup/export, a file (for example JSON, possibly including photos) is saved where you choose (this device or a location you pick such as Drive). We do not upload that file to our servers; you control the file.",
          ],
        },
        {
          heading: "4. Permissions and device services",
          paragraphs: [
            { ads: true, content: "Photo access is used only when you add or crop a profile photo." },
            { ads: false, content: "The App uses internet access for Google Play Billing. Photo access is used only when you add or crop a profile photo." },
          ],
        },
        {
          heading: "5. Children",
          paragraphs: [
            "The App is not directed at children under 13 (or the minimum age required in your country). Do not use the App if you are under that age.",
          ],
        },
        {
          heading: "6. Changes",
          paragraphs: [
            "We may update this policy. The “Last updated” date will change. Continued use after an update means you accept the revised policy.",
          ],
        },
        {
          heading: "7. Your choices",
          paragraphs: [
            "You can delete resumes in the App. Uninstalling removes local App data on that device unless you kept a backup file elsewhere.",
          ],
        },
        {
          ads: true,
          heading: "Advertising",
          paragraphs: [
            "The App shows banner and other ads. Advertising partners (for example Google AdMob) may collect or receive device and advertising identifiers, approximate location derived from IP, and interaction data to show and measure ads, including personalized ads where allowed. Partners may use cookies or similar technologies subject to their own policies.",
            [
              { text: "You can limit ad personalization in your device or Google account settings where available. See also " },
              { text: "Google’s privacy policy", href: "https://policies.google.com/privacy" },
              { text: "." },
            ],
          ],
        },
        {
          heading: "Optional AI features",
          paragraphs: [
            "If you use “Improve with AI” or similar, the text you choose to send may be transmitted to the configured AI provider to generate a response. Do not send sensitive data you do not want processed by that provider. The provider’s own privacy terms also apply.",
          ],
        },
        {
          heading: "Contact",
          paragraphs: [
            [
              { text: "Questions about privacy: use the developer contact options on the App’s Google Play listing or visit " },
              { text: "https://imranmelikov.org/contact", href: "https://imranmelikov.org/contact" },
            ],
          ],
        },
      ],
    },
    terms: {
      name: "Terms of Use — AI Resume Builder & CV Maker",
      developer: "Imran Melikov",
      dateLabel: "Last updated",
      updated: "7 October 2026",
      contactLabel: "Contact",
      contact: "https://imranmelikov.org/contact",
      intro: [
        "By downloading or using the App you agree to these Terms. If you do not agree, do not use the App. The App is provided by Imran Melikov.",
      ],
      sections: [
        {
          heading: "1. License",
          paragraphs: [
            "Personal, non-exclusive, non-transferable license for lawful personal or professional resume creation.",
          ],
        },
        {
          heading: "2. Free features",
          paragraphs: [
            "Create resumes on device; limited templates/colors; up to 2 different template-and-color combinations for export/share (same style does not consume another slot).",
          ],
        },
        {
          heading: "3. Premium features",
          paragraphs: [
            "All templates/colors, custom sections, duplicate, backup/restore, unlimited PDF export/share, as shown in-app.",
          ],
        },
        {
          heading: "4. Your content",
          paragraphs: ["You are responsible for accuracy and rights. Templates are provided “as is”."],
        },
        {
          heading: "5. Acceptable use",
          paragraphs: [
            { ads: false, content: "Do not use the App unlawfully." },
            { ads: true, content: "No circumventing purchases or limits, and no unlawful use." },
          ],
        },
        {
          heading: "6. Disclaimers",
          paragraphs: [
            "The App is provided “as is”. There is no guarantee of jobs, ATS passage, or uninterrupted service.",
          ],
        },
        {
          heading: "7. Changes",
          paragraphs: ["Terms may be updated. Continued use means acceptance."],
        },
        {
          ads: false,
          heading: "8. Premium subscriptions and lifetime (Google Play)",
          paragraphs: ["Premium is offered as:"],
          items: [
            "Monthly subscription (auto-renewing)",
            "Yearly subscription (auto-renewing)",
            "Lifetime (one-time purchase; not a subscription)",
          ],
          notes: [
            "Prices are shown in Google Play before you confirm. Subscriptions renew automatically unless you cancel at least 24 hours before the end of the current period. Management and cancellation are in Google Play → Payments & subscriptions (not a custom cancel button in this App). Canceling stops future renewals; you keep Premium until the end of the period already paid. Deleting the App does not cancel a subscription.",
            "One-time purchases (including lifetime) follow Google Play refund policies. Restore with the same Google account. Consumer / withdrawal rights in your country are not limited by this summary.",
          ],
        },
        {
          ads: true,
          heading: "Advertising",
          paragraphs: [
            "The free version shows ads (for example banners) from third parties. Premium removes or reduces ads according to the offer at purchase time.",
          ],
        },
        {
          heading: "Optional AI",
          paragraphs: ["AI suggestions may be inaccurate; review before using in a resume."],
        },
        {
          heading: "Contact",
          paragraphs: [
            [
              { text: "Google Play developer contact or " },
              { text: "https://imranmelikov.org/", href: "https://imranmelikov.org/" },
            ],
          ],
        },
      ],
    },
  },
  {
    title: "Outfit Planner",
    category: "Android",
    summary: "A wardrobe and outfit planner, still in development.",
    description: "Keep a wardrobe and plan outfits.",
    tags: ["Wardrobe", "Outfits"],
    marks: ["wardrobe"],
    href: "/outfit-planner",
    store: "",
    image: "/outfitplanner.png",
    enabled: true,
    technology: false,
    ads: false,
    landing: true,
    theme: "outfit",
    palette: {
      bg: "#0c0a12",
      ink: "#f6f3f8",
      muted: "#c9c0d0",
      accent: "#a34562",
      accent2: "#6d9ed4",
      card: "rgba(22, 14, 24, 0.78)",
    },
    features: [
      { title: "Wardrobe", text: "Keep the clothes you want to use." },
      { title: "Outfits", text: "Plan what to wear from that wardrobe." },
    ],
    privacy: {
      name: "Outfit Planner & Wardrobe",
      developer: "Imran Melikov",
      updated: "October 7, 2026",
      contact: "https://imranmelikov.org/contact",
      sections: [
        {
          heading: "1. Whose policy is this?",
          paragraphs: [
            "This policy covers the Outfit Planner & Wardrobe application (the “App”) provided by Imran Melikov (“we”). The App is for saving your clothes, creating outfits, planning them, and, if you choose, sharing them with others on the Hub.",
            [
              { text: "Privacy questions and data requests: " },
              { text: "imran.melikov84@gmail.com", href: "mailto:imran.melikov84@gmail.com" },
            ],
          ],
        },
        {
          heading: "2. What data do we process?",
          paragraphs: ["The App can be used in two ways:"],
          items: [
            "Offline demo: You can continue without creating an account. Clothes, outfits, and photos stay on your device. This data is not sent to a server.",
            "Account use: When you sign in with email or Google, your wardrobe is saved to your account on Supabase.",
          ],
          notes: [
            "Account information. If you create an account or sign in, we process your email address, display name, and account identifier. If you sign in with Google, this also includes the name, email, and account identifier that Google sends. Your password is not stored in the app as plain text. Supabase Auth handles the password securely. If a Hub share is approved, your display name is shown to other signed-in users. Your email address is not published on the Hub.",
            "Content you add. Clothing photos you choose from your gallery, the clothing name, category, color, brand, size, fabric, fit, condition, a purchase price if you add one, purchase date and notes, outfits, favorites, planned days, wear history, and your own category names. A photo is required to add a clothing item. The system photo picker is used. Continuous access to your whole gallery is not requested. The purchase price is a note. Card or bank details are not requested. When you use an account, photos are uploaded to Supabase Storage.",
            "Preferences. Theme, language, and unit of measurement are stored on your device. If you have an account, these settings can also be written to your account.",
            "Backup. The ZIP backup you export from Settings is saved to the location you choose. This file is not sent to a server automatically.",
            { ads: false, content: "Not in this version. There are no ads or advertising identifiers, no third-party analytics or crash SDK, no location, contacts, or SMS, and no in-app purchase or payment-card details. Supabase may keep technical logs, such as an IP address, for security. Those logs are not used to infer location or for advertising." },
            { ads: true, content: "There is no third-party analytics or crash SDK, no location, contacts, or SMS. Supabase may keep technical logs, such as an IP address, for security. Those logs are not used to infer location." },
          ],
        },
        {
          heading: "3. Why do we use the data?",
          paragraphs: [
            "We use it to create an account and tie your wardrobe to you, to store clothes and outfits, to show on the Hub the content you marked “Show to others” after an administrator approves it, to remove shares that break the rules, to make backups, and to answer support and deletion requests. We do not sell your data. We do not build an advertising profile.",
          ],
        },
        {
          heading: "4. Who is it shared with?",
          table: {
            headers: ["Recipient", "What for"],
            rows: [
              ["Supabase", "Authentication, database, and file storage. It processes data on our behalf."],
              ["Google", "Only if you choose “Continue with Google”. Google’s own privacy policy applies."],
              ["Other users", "Only content you submit to the Hub that is approved: a photo, clothing or outfit details, and your display name."],
              ["Competent authorities", "If the law requires it."],
            ],
          },
          notes: ["Wardrobe items you do not submit to the Hub stay private to you."],
        },
        {
          heading: "5. How long do we keep it?",
          paragraphs: [
            "Your data is kept for as long as your account exists. If you delete a clothing item or an outfit, the related record and files are removed. If you remove something from the Hub, it leaves the public list. It can remain in your wardrobe. After an account-deletion request, we aim to delete your account, your profile, your wardrobe records, and your uploaded photos within 30 days. If the law requires it, the relevant record may be kept longer. Offline demo data is on your device. Uninstalling the app or clearing the app data deletes that copy.",
          ],
        },
        {
          heading: "6. Deleting your account and data",
          paragraphs: [
            [
              { text: "Email " },
              { text: "imran.melikov84@gmail.com", href: "mailto:imran.melikov84@gmail.com" },
              { text: " from the email address you use in the app, with the subject line “Account deletion”. Your Supabase account, profile, settings, clothes, outfits, favorites, plans, history, uploaded photos, and approved Hub shares are deleted. If you signed in with Google, this does not delete your Google account. It deletes only your record in this app. Settings → Delete account;" },
            ],
            [
              { text: "This page is the deletion address used without installing the app: " },
              { text: "https://imranmelikov.org/contact", href: "https://imranmelikov.org/contact" },
            ],
          ],
        },
        {
          heading: "7. Security",
          paragraphs: [
            "Communication with the server uses HTTPS. Data is encrypted in transit. Supabase encrypts stored data on disk. Wardrobe rows are protected by access rules locked to your account.",
          ],
        },
        {
          heading: "8. Children",
          paragraphs: [
            [
              { text: "The App is not directed at children under 13. We do not knowingly collect personal data from anyone under 13. If we find such an account, we delete it. If you are a parent, write to " },
              { text: "imran.melikov84@gmail.com", href: "mailto:imran.melikov84@gmail.com" },
              { text: "." },
            ],
          ],
        },
        {
          heading: "9. Your rights",
          paragraphs: [
            [
              { text: "Depending on the law of your country, including the KVKK in Turkey, you may ask to access your data, have it corrected or deleted, and, to the extent the law allows, have the processing restricted. A ZIP backup lets you take a copy of your data. For requests, use " },
              { text: "imran.melikov84@gmail.com", href: "mailto:imran.melikov84@gmail.com" },
              { text: ". We may ask you to write from your account email so we can verify who you are." },
            ],
          ],
        },
        {
          heading: "10. International transfer",
          paragraphs: [
            "Supabase infrastructure may operate outside your country. When you use an account, your data is transferred to this provider in order to provide the service.",
          ],
        },
        {
          heading: "11. Changes",
          paragraphs: [
            [
              { text: "If we update this text, we change the date. The current text is at " },
              { text: "https://www.imranmelikov.org/outfit-planner", href: "https://www.imranmelikov.org/outfit-planner" },
              { text: "." },
            ],
          ],
        },
        {
          heading: "12. Contact",
          paragraphs: [
            "Imran Melikov",
            "Outfit Planner & Wardrobe",
            [
              { text: "imran.melikov84@gmail.com", href: "mailto:imran.melikov84@gmail.com" },
            ],
          ],
        },
      ],
    },
  },
  {
    title: "Example Ledger",
    category: "Example",
    enabled: false,
    summary: "A sample project so the list and the home rail can be checked.",
    description:
      "Sample project for the layout. Replace this text, the tags, and the image, or delete the whole block.",
    tags: ["Web", "Dashboard", "Reports"],
    marks: ["globe"],
    href: "/projects",
    image: "/example-ledger.svg",
  },
  {
    title: "Example Harbor",
    category: "Example",
    enabled: false,
    summary: "A second sample, with a different image and a different icon.",
    description:
      "Sample project for the layout. It sits under CineMovie on the projects page and beside it on the home rail.",
    tags: ["Security", "Audit"],
    marks: ["shield"],
    href: "/projects",
    image: "/example-harbor.svg",
  },
  {
    title: "Example Field",
    category: "Example",
    enabled: false,
    summary: "A third sample, so the home rail can scroll.",
    description:
      "Sample project for the layout. On the home page the arrow buttons appear when the cards no longer fit.",
    tags: ["Android", "Mobile"],
    marks: ["phone"],
    href: "/projects",
    image: "/example-field.svg",
  },
];

export const chess = {
  name: "Chess I/M",
  lede: "A personal interest in the game.",
  body: "A chess community focused on playing, learning, and continuous improvement.We organize games and tournaments through Lichess, Chess.com, and our community channels.Explore our content, chess bot, and courses on Instagram, YouTube, and Udemy.",
  accounts: [
    { label: "Lichess", href: "https://lichess.org/@/ImranMelikov" },
    { label: "Lichess team", href: "https://lichess.org/team/chess-im" },
    { label: "Chess.com", href: "https://www.chess.com/member/imran-melikov" },
    { label: "Chess.com team", href: "https://www.chess.com/club/chess-im" },
    { label: "Bot", href: "https://lichess.org/@/ImranMelikovBot" },
    { label: "WhatsApp channel", href: "https://whatsapp.com/channel/0029VbC9o9O1iUxbyXH2PO0N" },
    { label: "WhatsApp community", href: "https://chat.whatsapp.com/Ju2FBwlsRHL230bD7zIev0" },
    { label: "More", href: "https://chessim.taplink.bio/" },
  ],
  course: {
    label: "Udemy",
    title: "Chess for Beginners: Essential Concepts and Strategies",
    text: "A beginner course on the rules, tactics, and basic strategy.",
    href: "https://www.udemy.com/course/chess-essential-strategies/",
    image: "",
    poster: "chess",
    action: "View course",
    video: {
      title: "Chess for Beginners: Essential Concepts and Strategies",
      href: "https://www.udemy.com/course/chess-essential-strategies/",
      image: "",
      action: "View video",
    },
  },
  videos: [
    {
      label: "YouTube",
      title: "The Trap That EVERY Beginner Needs to Know",
      href: "https://www.youtube.com/watch?v=0YQLK9OM17M",
      labelHref: "https://www.youtube.com/@imranmelikov/shorts",
      image: "https://i.ytimg.com/vi/0YQLK9OM17M/hqdefault.jpg",
      action: "View video",
      enabled: true,
      home: true,
      page: true,
    },
    {
      label: "Instagram",
      title: "",
      href: "https://instagram.com/imranmelikov225",
      image: "",
      action: "View video",
      poster: "chess",
      enabled: true,
      home: true,
      page: true,
    },
  ],
  teaching: {
    enabled: false,
    preview: false,
    title: "Teaching",
    items: [
      {
        label: "Teaching",
        title: "Lessons can be listed here when teaching is open.",
        href: "https://www.udemy.com/course/chess-essential-strategies/",
        image: "",
        poster: "chess",
        action: "View teaching",
        video: false,
        enabled: true,
        home: false,
        page: true,
      },
    ],
  },
  games: [],
  notes: [],
};

export const mobiltech = {
  name: "MobilTech",
  lede: "Mobile technology products and retail.",
  note: "Phones and mobile technology products are on a separate site.",
  href: "https://mobiltech.imranmelikov.org",
  channels: [
    { label: "Instagram", href: "https://instagram.com/mobiltech.store", enabled: true },
    { label: "YouTube", href: "", enabled: false },
    { label: "TikTok", href: "https://www.tiktok.com/@mobiltech.store", enabled: true },
    { label: "Facebook", href: "https://facebook.com/share/1JMPbo7FHU", enabled: true },
    { label: "WhatsApp", href: "https://wa.me/994708989158", enabled: true },
    {
      label: "Google Maps",
      href: "https://www.google.com/maps/search/?api=1&query=9VHH%2BPG9%2C+8+November+Ave%2C+Baku",
      enabled: true,
    },
  ],
  videos: [
    {
      label: "Instagram",
      title: "",
      href: "https://instagram.com/mobiltech.store",
      action: "View video",
      poster: "business",
      enabled: true,
      home: true,
      page: true,
    },
    {
      label: "TikTok",
      title: "",
      href: "https://www.tiktok.com/@mobiltech.store",
      action: "View video",
      poster: "business",
      enabled: true,
      home: true,
      page: true,
    },
    {
      label: "YouTube",
      title: "YouTube",
      href: "",
      action: "View video",
      poster: "business",
      enabled: false,
      home: true,
      page: true,
    },
  ],
};

export const contact = {
  lede: "For project, company, or general enquiries.",
  endpoint: "https://formspree.io/f/xbloojbz",
};

export const pages = {
  "/": { theme: "light", title: "Imran Melikov" },
  "/about": { theme: "light", title: "About" },
  "/technology": { theme: "tech", title: "Technology" },
  "/projects": { theme: "light", title: "Projects" },
  "/cinemovie": { theme: "cinema", title: "CineMovie" },
  "/qr-barcode": { theme: "qr", title: "QR Barcode" },
  "/expense-tracker": { theme: "expense", title: "Expense Tracker" },
  "/ai-resume": { theme: "resume", title: "AI Resume Builder" },
  "/outfit-planner": { theme: "outfit", title: "Outfit Planner" },
  "/chess": { theme: "chess", title: "Chess I/M" },
  "/business": { theme: "business", title: "MobilTech" },
  "/contact": { theme: "light", title: "Contact" },
};

export const themeColor = {
  light: "#f3f6f9",
  tech: "#080c14",
  chess: "#0e0d0b",
  business: "#07111c",
  cinema: "#111827",
  qr: "#04110c",
  expense: "#070714",
  resume: "#07061a",
  outfit: "#0c0a12",
};
